/**
 * Einstiegspunkt der Web-App.
 *
 * Welche Ansicht erscheint, entscheidet `App` anhand der Sitzung; wohin es
 * innerhalb der angemeldeten Anwendung geht, sagt die Adresse (`lib/router.ts`).
 */
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
/**
 * Farben, Abstände, Schriften — erzeugt aus `packages/ui/src/tokens.ts`. Muss
 * **vor** der App stehen, damit keine Ansicht kurz ohne Gestaltung erscheint.
 */
import "@hausmeter/ui/theme.css";
/**
 * Das Diagramm bringt sein eigenes Stylesheet mit — das Grundgerüst von uPlot
 * und das Ablesefenster, das außerhalb von React entsteht (HM-054).
 */
import "@hausmeter/ui/chart.css";
import { App } from "./app.js";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Werte veralten schnell; Stammdaten nicht. Der Standard ist bewusst
      // kurz und wird je Abfrage überschrieben, wo es sich lohnt.
      staleTime: 5_000,
      refetchOnWindowFocus: true,
    },
  },
});

const container = document.getElementById("root");
if (!container) throw new Error("Das Wurzelelement #root fehlt in index.html.");

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </StrictMode>,
);
